import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/w/roles')({
  staticData: { breadcrumb: 'Roles', breadcrumbKey: 'K_BREADCRUMB_ROLES' },
  component: RolesLayout,
});

function RolesLayout() {
  return <Outlet />;
}
